import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import type { BotInstancesResponse } from "../types";

// Powers the target-selector on /control — the ONE page that addresses a
// specific bot_instance_id instead of the merged view used everywhere else.
export function useBotInstances() {
  return useQuery({
    queryKey: ["bot-instances"],
    queryFn: () => api.get<BotInstancesResponse>("/bot-instances"),
    refetchInterval: 10000,
  });
}
